import React,{useState} from 'react';
import { Button } from 'react-bootstrap';
import BodySidebar from './filters/BodySidebar';
import FooterSidebar from './filters/FooterSidebar';
import HeaderSidebar from './filters/HeaderSidebar';
import TextureMob from './TextureMob';
import ToolsMob from './ToolsMob';
import TextureSidebar from './filters/TextureSidebar';
import { checkType } from '../../../utils/checkType';
import MenuTextureMob from './MenuTextureMob';
import { sortTexture } from '../../../utils/sortTexture';
import { searchTexture } from '../../../utils/searchTexture';

const Footer = ({mainState}) => {
    const [footerBody,setFooterBody] = useState(false);
    const [showTxture,setShowTxture] = useState(true);
    const [showTools,setShowTools] = useState(false);
    const [showSidebar,setShowSidebar] = useState(false);
    const [txtureSearch,setTxtureSearch] = useState(false);
    const [search,setSearch] = useState("");

    const showBodyFooter = () => {
        setFooterBody(!footerBody);
    };
    const handleShowTxture = () => {
        setShowTxture(true);
        setShowTools(false);
    };
    const handleShowTools = () => {
        setShowTxture(false);
        setShowTools(true);
    };
    const handleShowSidebar = () => {
        setShowSidebar(true);
    };
    const handleHideSidebar = ff => {
        if(ff === false) setShowSidebar(ff);
    };
    const handleShowTextureSearch = (event) =>{
        if (event) {
            setTxtureSearch(true);
        }else{
            setTxtureSearch(false);
        }
    }

    const handleSearchTecture = (event) => {
        setSearch(event);
    }
    // -----------------------------------------------------------------------
    const check_Type_Model = checkType(mainState);
    const takeTexture = sortTexture(mainState);
    const searchState = searchTexture(takeTexture,search);

    let isMenu = null;
    if (check_Type_Model) {
        isMenu = <MenuTextureMob txture={mainState}/>
    }else{
        isMenu = <TextureMob txture={mainState}/>
    }
    
    let isShowTexture = "";
    if (showTxture) {
        isShowTexture = isMenu
    }else if(showTools){
        isShowTexture = <ToolsMob/>
    };


    // let isSearchTexture = "";
    // if (txtureSearch) {
    //     isSearchTexture = <TextureSidebar txtureee={searchState}/>;
    // }
    // else{
    //     isSearchTexture = <BodySidebar/>
    // }

    return ( 
        <>
            <div className={footerBody ? 'footer-container footer-container-fadein' : 'footer-container'}>
                <div className='footer-header'>
                    <div className='footer-choice-product' onClick={() => {
                        handleShowTxture();
                        if(!footerBody) showBodyFooter();
                    }}><p>انتخاب محصول <span className={showTxture ? 'footer-underline active-underline' : 'footer-underline'}></span></p></div>
                    <div className='footer-tools' onClick={() => {
                        handleShowTools();
                        if(!footerBody) showBodyFooter();
                    }}><p>ابعاد زاویه و چینش <span className={showTools ?'footer-underline active-underline' : 'footer-underline'}></span></p></div>
                    <div className='footer-search'>
                        <Button type="botton" variant="none" onClick={handleShowSidebar} size="sm" className="fa fa-search w-100"/>
                    </div>
                    <div className='footer-close'>
                        <Button type="botton" variant="none" onClick={showBodyFooter}><i className={footerBody ? 'fa fa-angle-down' : 'fa fa-angle-up'}></i></Button>
                    </div>
                </div>
                <div className='footer-body' style={footerBody ? {display:'block'}: {display:'none'}}>
                    {isShowTexture}
                </div>
            </div>
            <div className={showSidebar ? "sidebar d-block" : "sidebar d-none"}>
                <HeaderSidebar hSidebar={handleHideSidebar} handleSrch={handleSearchTecture} srchT={handleShowTextureSearch}/>
                    {/* {isSearchTexture} */}
                    <TextureSidebar txtureee={searchState}/>
                <FooterSidebar/>
            </div>
        </>
    );
}
 
export default Footer;